// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-bottom-navigation {
  display: flex;
  max-width: 100%;
  overflow: hidden;
  position: absolute;
  transition: transform, color, 0.2s, 0.1s cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-bottom-navigation {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-bottom-navigation--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-bottom-navigation {
  border-radius: 0;
}
:where(.vuetify-styles) .v-bottom-navigation {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-bottom-navigation--active {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}

:where(.vuetify-styles) .v-bottom-navigation__content {
  display: flex;
  flex: none;
  font-size: 0.75rem;
  justify-content: center;
  transition: inherit;
  width: 100%;
}
:where(.vuetify-styles) .v-bottom-navigation .v-bottom-navigation__content > .v-btn {
  font-size: inherit;
  height: 100%;
  max-width: 168px;
  min-width: 80px;
  text-transform: none;
  transition: inherit;
  width: auto;
}
:where(.vuetify-styles) .v-bottom-navigation .v-bottom-navigation__content > .v-btn {
  border-radius: 0;
}
:where(.vuetify-styles) .v-bottom-navigation .v-bottom-navigation__content > .v-btn .v-btn__content,
:where(.vuetify-styles) .v-bottom-navigation .v-bottom-navigation__content > .v-btn .v-btn__icon {
  transition: inherit;
}
:where(.vuetify-styles) .v-bottom-navigation .v-bottom-navigation__content > .v-btn .v-btn__icon {
  font-size: 1.5rem;
}
:where(.vuetify-styles) .v-bottom-navigation--grow .v-bottom-navigation__content > .v-btn {
  flex-basis: 0;
  flex-grow: 1;
}
:where(.vuetify-styles) .v-bottom-navigation--shift .v-bottom-navigation__content .v-btn:not(.v-btn--selected) .v-btn__content > span {
  transition: inherit;
  opacity: 0;
}
:where(.vuetify-styles) .v-bottom-navigation--shift .v-bottom-navigation__content .v-btn:not(.v-btn--selected) .v-btn__content {
  transform: translateY(0.5rem);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VBottomNavigation/VBottomNavigation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qEAAqE;AACvE;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,wOAAwO;AAC1O;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".v-bottom-navigation {\n  display: flex;\n  max-width: 100%;\n  overflow: hidden;\n  position: absolute;\n  transition: transform, color, 0.2s, 0.1s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-bottom-navigation {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-bottom-navigation--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-bottom-navigation {\n  border-radius: 0;\n}\n.v-bottom-navigation {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-bottom-navigation--active {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n\n.v-bottom-navigation__content {\n  display: flex;\n  flex: none;\n  font-size: 0.75rem;\n  justify-content: center;\n  transition: inherit;\n  width: 100%;\n}\n.v-bottom-navigation .v-bottom-navigation__content > .v-btn {\n  font-size: inherit;\n  height: 100%;\n  max-width: 168px;\n  min-width: 80px;\n  text-transform: none;\n  transition: inherit;\n  width: auto;\n}\n.v-bottom-navigation .v-bottom-navigation__content > .v-btn {\n  border-radius: 0;\n}\n.v-bottom-navigation .v-bottom-navigation__content > .v-btn .v-btn__content,\n.v-bottom-navigation .v-bottom-navigation__content > .v-btn .v-btn__icon {\n  transition: inherit;\n}\n.v-bottom-navigation .v-bottom-navigation__content > .v-btn .v-btn__icon {\n  font-size: 1.5rem;\n}\n.v-bottom-navigation--grow .v-bottom-navigation__content > .v-btn {\n  flex-basis: 0;\n  flex-grow: 1;\n}\n.v-bottom-navigation--shift .v-bottom-navigation__content .v-btn:not(.v-btn--selected) .v-btn__content > span {\n  transition: inherit;\n  opacity: 0;\n}\n.v-bottom-navigation--shift .v-bottom-navigation__content .v-btn:not(.v-btn--selected) .v-btn__content {\n  transform: translateY(0.5rem);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
